import { render, staticRenderFns } from "./StepUpForgot.vue?vue&type=template&id=9848bb98&scoped=true&"
import script from "./StepUpForgot.vue?vue&type=script&lang=ts&"
export * from "./StepUpForgot.vue?vue&type=script&lang=ts&"
import style0 from "./StepUpForgot.vue?vue&type=style&index=0&id=9848bb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9848bb98",
  null
  
)

export default component.exports